import { ISelect } from './SelectComponent.types'
import { Container } from './styles'

export function Select({
  className,
  label,
  options,
  value,
  onChange,
  disabled,
  ...props
}: ISelect): JSX.Element {
  return (
    <Container className={className} disabled={disabled}>
      <select onChange={onChange} value={value} {...props}>
        <option aria-label={label} value="">
          {label}
        </option>
        {options?.map(op => {
          return (
            <option key={op} value={op}>
              {op}
            </option>
          )
        })}
      </select>
    </Container>
  )
}
